module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "venue-title-bar",
    style: (_vm.pageTitleBar)
  }, [_c('div', {
    staticClass: "venue-title"
  }, [_vm._v("\n      RESULTS\n    ")]), _vm._v(" "), (_vm.uploadedImageName) ? _c('div', {
    staticClass: "venue-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.uploadedImagePath,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "the-time"
  }, [_vm._v("\n      " + _vm._s(_vm.theTime) + "\n    ")])]), _vm._v(" "), _c('Ticker'), _vm._v(" "), _c('div', {
    staticClass: "flex-race-container"
  }, _vm._l((_vm.screenData), function(race) {
    return _c('div', {
      key: race.index,
      staticClass: "flex-race-item",
      class: {
        noedge: race.index % 3 === 0
      }
    }, [_c('div', {
      staticClass: "race-title-bar",
      style: (_vm.raceTitleBar)
    }, [_c('div', {
      staticClass: "race-venue-flag"
    }), _vm._v(" "), _c('div', {
      staticClass: "race-venue-name"
    }, [_c('div', {
      staticClass: "venue-name"
    }, [_vm._v("\n            " + _vm._s(_vm.venueDisplayName(race.ve)) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "race-name"
    }, [_vm._v("\n            " + _vm._s(_vm._f("race")(race.fn)) + " - " + _vm._s(_vm._f("satime")(race.raceDateTime)) + "\n          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "markets-container"
    }, [_c('ResultMarket', {
      attrs: {
        "race": race
      }
    })], 1)])
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a8f367e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Results.vue
// module id = 227
// module chunks = 1